module.exports = __webpack_public_path__ + "static/media/solo3.2e118916.JPG";